import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

export default Route.extend({
  router: service(),

  redirect() {
    this.router.replaceWith('/cms/privacy');
  }

});
